import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SimpleButtonDropdown from '../../../components/SimpleButtonDropdown';
import { handleDropdownSelection, getDropdownDisplayProps } from '../../../utils/Utils';

class ButtonDropDown extends Component {
    static propTypes = {
        values: PropTypes.arrayOf(PropTypes.object).isRequired,
        defaultValue: PropTypes.string.isRequired,
        currentValue: PropTypes.string,
        className: PropTypes.string,
        hasEmptyValue: PropTypes.bool,
        multiSelect: PropTypes.bool,
        defaultSelectedValues: PropTypes.arrayOf(PropTypes.string),
        keys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
        onChangeValue: PropTypes.func
    };

    static defaultProps = {
        hasEmptyValue: true,
        multiSelect: false,
        defaultSelectedValues: [],
        onChangeValue: () => { }
    };

    state = {
        dropdownOpen: false,
        selectedValue: '',
        selectedValues: this.props.defaultSelectedValues || []
    };

    componentDidUpdate(prevProps) {
        // Sync state with props when defaultSelectedValues change
        if (JSON.stringify(prevProps.defaultSelectedValues) !== JSON.stringify(this.props.defaultSelectedValues)) {
            this.setState({ selectedValues: this.props.defaultSelectedValues || [] });
        }
    }

    onDropdownItemClick = (index) => {
        const result = handleDropdownSelection({
            index,
            values: this.props.values,
            multiSelect: this.props.multiSelect,
            selectedValues: this.state.selectedValues,
            onChangeValue: this.props.onChangeValue
        });

        if (this.props.multiSelect) {
            this.setState({ selectedValues: result.selectedValues });
        } else {
            this.setState({ selectedValue: result.selectedValue });
        }
    };

    render() {
        // Handle missing names by showing "Unknown name (CODE)"
        const values = this.props.values.map((e) => e.name || `Unknown name (${e.value || 'N/A'})`);

        const { text, badgeCount, hasEmptyValue } = getDropdownDisplayProps({
            multiSelect: this.props.multiSelect,
            selectedValue: this.state.selectedValue,
            selectedValues: this.state.selectedValues,
            defaultValue: this.props.defaultValue,
            hasEmptyValueProp: this.props.hasEmptyValue
        });

        return (
            <SimpleButtonDropdown
                text={text}
                badgeCount={badgeCount}
                values={values}
                keys={this.props.keys}
                className={this.props.className}
                isScrollable={true}
                hasEmptyValue={hasEmptyValue}
                multiSelect={this.props.multiSelect}
                selectedValues={this.state.selectedValues}
                onChangeValue={(index) => this.onDropdownItemClick(index)}
            />
        );
    }
}

export default ButtonDropDown;
